import { render, staticRenderFns } from "./CollectionBackPerformanceForAmount.vue?vue&type=template&id=a4715090&scoped=true"
import script from "./CollectionBackPerformanceForAmount.vue?vue&type=script&lang=js"
export * from "./CollectionBackPerformanceForAmount.vue?vue&type=script&lang=js"
import style0 from "./CollectionBackPerformanceForAmount.vue?vue&type=style&index=0&id=a4715090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4715090",
  null
  
)

export default component.exports